import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import * as fa from '@fortawesome/free-solid-svg-icons';

import { Message } from '../../classes/message';
import { MessageService } from '../../services/message.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../classes/user';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';
import NotificationTypes from '../../constants/notification-types';
import { Notification } from '../../classes/notification';
import { environment } from 'src/environments/environment';
import Locales from '../../constants/locales';
import { Organization } from 'src/app/classes/organization';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})

export class MainComponent implements OnInit {
  @ViewChild('messagesDropdown') messagesDropdown!: NgbDropdown

  initiated = false

  notificationTypes = NotificationTypes

  fa = fa
  messages: Message[] = []
  messageCount = 0
  currentUser: User = new User()

  toasts: Notification[] = []
  toastId = 0

  messageFilters: string[] = []

  locale = $localize.locale
  environment = environment
  locales = Locales

  organization = new Organization()

  constructor(
    private messageService: MessageService,
    private notificationService: NotificationService,
    private userService: UserService,
    private settingsService: SettingsService,
    public router: Router) { }

  ngOnInit(): void { 
    this.initiated = true
  }

  removeMessage(message: Message) {
    this.messages = this.messages.filter(m => m.id !== message.id)
  }

  removeToast(toast: Notification) {
    this.toasts = this.toasts.filter(t => t.id !== toast.id)
  }

  clearToasts() {
    this.toasts = []
    this.messages = []
  }

  changeLanguage(language: string) {
    document.cookie = `admin_lang=${language};max-age=${365 * 24 * 60 * 60};path=/`;
    window.location.href = `/${ environment.base_url ? environment.base_url : '' }${language}${this.router.url}`
  }

  filter(message: Message): boolean {
    if (message.from_contact_id && !this.messageFilters.includes(`contact:${message.from_contact_id}`))
      return true
    else if (message.from_employee_id && !this.messageFilters.includes(`employee:${message.from_employee_id}`))
      return true
    else
      return false
  }

  toggle(event: any) {
    if (event == false) {
      this.messageCount = 0
    }
  }

}
